import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useSearchParamValue = (
  location: Location | ReturnType<typeof useLocation>,
  searchParam: string,
) => {
  const { search } = location;
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const searchParamValue = searchParams.get(searchParam);

  return searchParamValue;
};
